/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.button",
    title: "Email Button",
    description: "A centered branded call-to-action button for platform emails.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "label": {
            title: "Label",
            type: "string",
            description: "The button text.",
            required: true
        },
        "url": {
            title: "URL",
            type: "uri",
            description: "The URL the button links to.",
            required: true
        }
    }
});

var $ = require("../../../uam/scafolding.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.button",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var label = (options && options.label) ? options.label : "Continue";
    var url   = (options && options.url)   ? options.url   : "#";
    var cfg = $.config;
    var primary = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.primary) || "#C48D2F";
    var background = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.background) || "#FFFFFF";

    var html = `<tr>
  <td align="center" style="padding:20px 20px;">
    <a href="${url}"
       style="display:inline-block;padding:0.875rem 2rem;background:${background};color:${primary};font-family:Arial,Helvetica,sans-serif;font-size:1rem;font-weight:bold;text-decoration:underline;border:0.1875rem solid ${primary};border-radius:9999px;">
      ${label}
    </a>
  </td>
</tr>`;

    var text = `${label}: ${url}`;

    return { html, text };
};
